export const SENTRY_IGNORED_ERROR_PATTERNS = [
  /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/i,
]

const CANCELLED_REQUEST_PATTERNS = [
  /^(?:AxiosError:\s*)?Request aborted$/i,
  /^(?:AxiosError:\s*)?(?:canceled|cancelled)$/i,
  /^(?:AbortError:\s*)?(?:The operation was aborted|This operation was aborted|signal is aborted without reason)\.?$/i,
]

function errorText (value) {
  if (typeof value === 'string') return value
  if (!value || typeof value !== 'object') return ''
  return [value.name, value.message, value.value].filter(Boolean).join(': ')
}

export function shouldInitialiseSentry ({ dsn, isProductionBuild, hostname, isNative }) {
  if (!dsn || !isProductionBuild) return false
  if (isNative) return true
  return hostname === 'yumnia.com' || hostname === 'www.yumnia.com'
}

export function isCancelledRequest (value) {
  if (value?.code === 'ERR_CANCELED') return true
  if (value?.name === 'CanceledError') return true

  const text = errorText(value)
  return CANCELLED_REQUEST_PATTERNS.some(pattern => pattern.test(text))
}

export function shouldIgnoreSentryEvent (event, hint = {}) {
  const values = [
    hint.originalException,
    event?.message,
    event?.logentry?.message,
    ...(event?.exception?.values || []),
  ]

  return values.some(value => {
    const text = errorText(value)
    return isCancelledRequest(value) || SENTRY_IGNORED_ERROR_PATTERNS.some(pattern => pattern.test(text))
  })
}
